import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function leadScoringListRequest(urlParams = {}) {
  return request({ method: 'get', url: urls.leadScoringList, urlParams, headers: getHeaders() });
}

export async function leadScoringItemRequest(urlParams = {}) {
  const url = urls.leadScoringItem;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}

export async function leadScoringCreateRequest(urlParams, data) {
  return request({
    method: 'post',
    url: urls.leadScoringCreate,
    data,
    urlParams,
    headers: getHeaders(),
  });
}

export async function leadScoringUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.leadScoringUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function leadScoringRemoveRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.leadScoringRemove,
    urlParams,
    headers: getHeaders(),
  });
}

export async function leadScoringTestAttributes(urlParams, from, to, connector, attributes) {
  return request({
    method: 'post',
    url: urls.leadScoringTest,
    urlParams,
    data: {
      from,
      to,
      connector,
      scoring_attributes: attributes,
    },
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/leadScoring.js